import React from 'react'

import { Col, Form } from '_zari/core'

const MontoTotalFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='MONTO TOTAL' htmlFor='input-suma-montoTotal' md={12} />
      <Col md={12}>
        <Form.InputNumber id='input-suma-montoTotal' name='input-suma-montoTotal' disabled value={iValue} onChange={() => {}} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoTotalFormGroup)
